import React from 'react';
import isEmpty from 'lodash/isEmpty';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import NewButton from '../Buttons/NewButton';
import SimpleTable from './SimpleTable';
import {makeTableData} from './utils';
import useStyles from './styles';

const View = ({
  // startDate,
  // setStartDate,
  // endDate,
  // setEndDate,
  onRowClick,
  toggleNewForm,
  data,
  isBusy,
}) => {

  return <>
    <Header {...{toggleNewForm}}/>
    <UsersTable {...{isBusy, onRowClick, data}} />
  </>;
};

export const Header = ({toggleNewForm}) => {

  // const classes = useStyles();

  return <>
    <Grid item>
      <NewButton onClick={toggleNewForm}/>
    </Grid>
  </>;
}

export const UsersTable = ({isBusy, data, onRowClick}) => {

  const classes = useStyles();

  const listData = makeTableData(data);

  const tableColumns = [
    { width: 150, flexGrow: 1, label: 'Nome', dataKey: 'name', numeric: false },
    { width: 150, flexGrow: 1, label: 'Email', dataKey: 'email', numeric: false },
  ];

  return isBusy
    ? <Grid container xs={12} justify='center'>
      <CircularProgress className={classes.spinner}/>
    </Grid>
    : !isEmpty(listData)
    ? <Grid item className={classes.usersContainer}>
      <SimpleTable
        rowCount={listData.length}
        list={listData}
        tableWidth={window.innerWidth > 576 ? null : 600}
        rowHeight={48}
        onRowClick={onRowClick}
        columns={tableColumns}
      />
    </Grid>
    : <Grid container xs={12} justify='center'>
      <Typography variant='h6' className={classes.title}>
        Nenhum item encontrado...
      </Typography>
    </Grid>;
};

export default View;
